import { useEffect, useCallback } from "react";
import Cookie from "cookie-universal";
import { useAuth } from "../context/AuthContext";
import { authAxios } from "../Axios/createAxios";

function RefreshToken() {
  const { isAuth, checkAuth } = useAuth();
  const refreshToken = useCallback(async () => {
    try {
      const res = await authAxios.post(`/refresh`);
      console.log(res);
      const { access_token: newToken } = res.data;
      if (newToken) {
        Cookie().set("bearer", newToken);
      }
    } catch (error) {
      console.error("Failed to refresh token", error);
      Cookie().remove("bearer");
      throw error;
    } finally {
      checkAuth();
      console.log("finally");
    }
  }, [checkAuth]);

  useEffect(() => {
    if (!isAuth) {
      return;
    }
    console.log("from refresh");

    const interval = setInterval(() => {
      refreshToken();
    }, 50 * 1000 * 60);

    return () => clearInterval(interval);
  }, [refreshToken, isAuth]);
  return null;
}
export default RefreshToken;
